import React from 'react';
import { Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import AdminPanel from '../components/AdminPanel';
import './AdminPage.css';

const AdminPage: React.FC = () => {
  const { user, canAdmin } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!canAdmin()) {
    return (
      <div className="admin-page">
        <div className="access-denied">
          <h2>접근 권한이 없습니다</h2>
          <p>이 페이지를 보려면 Admin 권한이 필요합니다.</p>
          <p>현재 권한: {user.role.toUpperCase()}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <Toaster position="top-right" />
      <header className="admin-header">
        <div className="admin-header-content">
          <h1 className="admin-title">관리자 대시보드</h1>
          <nav className="admin-nav">
            <a href="/">메인으로</a>
          </nav>
        </div>
      </header>
      <main className="admin-main">
        <AdminPanel />
      </main>
    </div>
  );
};

export default AdminPage;